import { useState } from 'react';
import DOMPurify from 'dompurify';
import './Accordion.scss';
import chevronUp from '../../../assets/images/chevron2Up.svg';
import chevronDown from '../../../assets/images/chevron2Down.svg';
import PropTypes from 'prop-types';

const Accordion = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);
  const handleVisibilityToggle = () => setIsOpen(!isOpen);

  return (
    <section className="accordion-cont">
      <div>
        <h2>
          <button
            tab-index="0"
            aria-expanded={isOpen}
            onClick={handleVisibilityToggle}
            className="accordion-cont_title"
            id={`acc-title-${question.replace(/\s+/g, '').substring(0, 10)}`}
            aria-controls={`acc-content-${question
              .replace(/\s+/g, '')
              .substring(0, 10)}`}
            label="question1"
          >
            <span
              className="accordion-cont_title_content"
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(question),
              }}
            />
            <span className="accordion-cont_title_chevron">
              <img
                src={isOpen ? chevronUp : chevronDown}
                alt="Down arrow"
                focusable="false"
                aria-hidden="true"
                className="accordion-cont_title_chevron_img"
              />
            </span>
          </button>
        </h2>
      </div>
      <div
        hidden={!isOpen}
        className="accordion-cont_details"
        id={`acc-content-${question.replace(/\s+/g, '').substring(0, 10)}`}
        aria-labelledby={`acc-title-${question
          .replace(/\s+/g, '')
          .substring(0, 10)}`}
      >
        <p>
          <span
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(answer),
            }}
          />
        </p>
      </div>
      <div hidden={isOpen} className="accordion-cont_normal" />
      <div hidden={!isOpen} className="accordion-cont_exp" />
    </section>
  );
};

Accordion.propTypes = {
  question: PropTypes.string.isRequired,
  answer: PropTypes.string.isRequired,
};

export default Accordion;
